var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_318)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.25C6.66848 12.25 6.35054 12.3817 6.11612 12.6161C5.8817 12.8505 5.75 13.1685 5.75 13.5V19.5C5.75 19.8315 5.8817 20.1495 6.11612 20.3839C6.35054 20.6183 6.66848 20.75 7 20.75H17C17.3315 20.75 17.6495 20.6183 17.8839 20.3839C18.1183 20.1495 18.25 19.8315 18.25 19.5V13.5C18.25 13.1685 18.1183 12.8505 17.8839 12.6161C17.6495 12.3817 17.3315 12.25 17 12.25H7ZM5.05546 11.5555C5.57118 11.0397 6.27065 10.75 7 10.75H17C17.7293 10.75 18.4288 11.0397 18.9445 11.5555C19.4603 12.0712 19.75 12.7707 19.75 13.5V19.5C19.75 20.2293 19.4603 20.9288 18.9445 21.4445C18.4288 21.9603 17.7293 22.25 17 22.25H7C6.27065 22.25 5.57118 21.9603 5.05546 21.4445C4.53973 20.9288 4.25 20.2293 4.25 19.5V13.5C4.25 12.7707 4.53973 12.0712 5.05546 11.5555Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7626 15.2626C11.0908 14.9344 11.5359 14.75 12 14.75C12.4641 14.75 12.9092 14.9344 13.2374 15.2626C13.5656 15.5908 13.75 16.0359 13.75 16.5C13.75 16.9641 13.5656 17.4092 13.2374 17.7374C12.9092 18.0656 12.4641 18.25 12 18.25C11.5359 18.25 11.0908 18.0656 10.7626 17.7374C10.4344 17.4092 10.25 16.9641 10.25 16.5C10.25 16.0359 10.4344 15.5908 10.7626 15.2626ZM12 16.25C11.9337 16.25 11.8701 16.2763 11.8232 16.3232C11.7763 16.3701 11.75 16.4337 11.75 16.5C11.75 16.5663 11.7763 16.6299 11.8232 16.6768C11.8701 16.7237 11.9337 16.75 12 16.75C12.0663 16.75 12.1299 16.7237 12.1768 16.6768C12.2237 16.6299 12.25 16.5663 12.25 16.5C12.25 16.4337 12.2237 16.3701 12.1768 16.3232C12.1299 16.2763 12.0663 16.25 12 16.25Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.25C11.138 4.25 10.3114 4.59241 9.7019 5.2019C9.09241 5.8114 8.75 6.63805 8.75 7.5V11.5C8.75 11.9142 8.41421 12.25 8 12.25C7.58579 12.25 7.25 11.9142 7.25 11.5V7.5C7.25 6.24022 7.75044 5.03204 8.64124 4.14124C9.53204 3.25044 10.7402 2.75 12 2.75C13.2598 2.75 14.468 3.25044 15.3588 4.14124C16.2496 5.03204 16.75 6.24022 16.75 7.5V11.5C16.75 11.9142 16.4142 12.25 16 12.25C15.5858 12.25 15.25 11.9142 15.25 11.5V7.5C15.25 6.63805 14.9076 5.8114 14.2981 5.2019C13.6886 4.59241 12.862 4.25 12 4.25Z",
    fill: "#B5B5B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.140272733021fcd4df97454d86cab8b0.svg";
export { ForwardRef as ReactComponent };